export const FormSiteSpaces = ({ payAndDisplaySpaces, setPayAndDisplaySpaces, preAllocatedSpaces, setPreAllocatedSpaces, disabledSpaces, setDisabledSpaces, permitSpaces, setPermitSpaces, otherSpaces, setOtherSpaces }) => {
    return (
        <>
            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Pay and Display Spaces</p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="number" value={ payAndDisplaySpaces } onChange={ (e) => setPayAndDisplaySpaces(e.target.value) } />
                    </div>
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Pre-Allocated Spaces</p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="number" value={ preAllocatedSpaces } onChange={ (e) => setPreAllocatedSpaces(e.target.value) } />
                    </div>
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Disabled Spaces</p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="number" value={ disabledSpaces } onChange={ (e) => setDisabledSpaces(e.target.value) } />
                    </div>
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Permit Spaces</p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="number" value={ permitSpaces } onChange={ (e) => setPermitSpaces(e.target.value) } />
                    </div>
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Other Spaces</p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="number" value={ otherSpaces } onChange={ (e) => setOtherSpaces(e.target.value) } />
                    </div>
                </div>
            </div>
        </>
    )
}